import React from 'react';
import BaseDropdown from './BaseDropdown';
import { useUsecaseStructure } from './UsecaseStructureContext';

const UsecaseDropdown = ({ branch, value, onChange, ...props }) => {
  const { getUsecases } = useUsecaseStructure();
  const options = getUsecases(branch);

  return (
    <BaseDropdown
      options={options}
      value={value}
      onChange={onChange}
      label="Usecase"
      placeholder="Select a usecase"
      disabled={!branch}
      {...props}
    />
  );
};

export default UsecaseDropdown; 